import { render, staticRenderFns } from "./text-filter.vue?vue&type=template&id=135fb218"
import script from "./text-filter.vue?vue&type=script&lang=js"
export * from "./text-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('135fb218')) {
      api.createRecord('135fb218', component.options)
    } else {
      api.reload('135fb218', component.options)
    }
    module.hot.accept("./text-filter.vue?vue&type=template&id=135fb218", function () {
      api.rerender('135fb218', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/filter/v1/text-filter.vue"
export default component.exports